import { css } from 'styled-components';

export const shadow = css`
  box-shadow: 0 4px 4px -2px rgb(0 0 0 / 25%);
`;
